import { uiText } from '../i18n/uiText';
import { useEffect, useRef } from 'react';
import { useConfirm } from '../store/ConfirmContext';

// Transient decisions (sanctions, rescheduling) should not be resurrected as
// persistent drafts. Guard accidental dismissal without storing their values.
export default function useProtectedClose(dirty, close, busy = false) {
  const confirm = useConfirm();
  const mounted = useRef(true), pending = useRef(false);
  useEffect(() => { mounted.current = true; return () => { mounted.current = false; }; }, []);
  useEffect(() => {
    if (!dirty) return;
    const protect = event => { event.preventDefault(); event.returnValue = ''; };
    window.addEventListener('beforeunload', protect);
    return () => window.removeEventListener('beforeunload', protect);
  }, [dirty]);
  return async () => {
    if (busy || pending.current) return;
    pending.current = true;
    try {
      if (dirty && !await confirm(uiText("В форме есть несохранённые изменения. Закрыть её без сохранения?"), { title: uiText("Несохранённые изменения"), confirmLabel: uiText("Закрыть без сохранения"), cancelLabel: uiText("Продолжить заполнение") })) return;
      if (mounted.current) close?.();
    } finally { pending.current = false; }
  };
}
